import { camelCase, isString, startCase } from "lodash";

export function makeSlug(text) {
  if (!isString(text)) {
    return "";
  }

  return textLowerCase(text).split(" ").join("-");
}

export function textLowerCase(text) {
  if (!isString(text)) {
    return "";
  }
  return text.toLowerCase();
}

export function textStarCase(text) {
  return startCase(text);
}

export function textCamelCase(text) {
  return camelCase(text);
}

// text to number
export function textToNumber(text) {
  // Use parseFloat to convert the text to a number
  const number = parseFloat(text);

  // Check if the result is a valid number
  if (isNaN(number)) {
    return 0;
  }

  return number;
}
